import featureFlagEnums from '@enums/feature-flags';
import routeNames from '@enums/route-names';
import PreparationPage from './preparation.vue';
import guardsMap from '@/js/pages/preparation/preparation-guard-map';
import { recordSubCampaignInShell } from '@/js/webshell-embed/recently-visited-entities';

const defaultBeforeEnter = async (to, from, next) => {
    await guardsMap[to.name](to, from, next);
};

// Empty component for child routes that use the parent component's rendering
const EmptyRouterView = { template: '<div />' };

const routes = [
    {
        path: '/preparation',
        id: 'preparation',
        featureToggle: 'canAccessPreparation',
        component: PreparationPage,
        linkText: 'navBar.preparation',
        index: 1,
        meta: {
            canAccess: featureFlagEnums.canAccessPreparation,
            isSideBarCalendarExpanded: true,
            tabTitle: 'navBar.preparation',
        },
        beforeEnter(to, from, next) {
            next();
        },
        children: [
            // Default route to ensure that all '/preparation' requests are redirected to the preparationAllCampaignsView.
            {
                path: '',
                name: 'preparation',
                redirect: { name: routeNames.preparationAllCampaignsView },
            },
            {
                path: 'allCampaignsView',
                name: routeNames.preparationAllCampaignsView,
                component: EmptyRouterView,
                beforeEnter: defaultBeforeEnter,
            },
            {
                path: 'singleCampaignView/:campaignId',
                name: routeNames.preparationSingleCampaignView,
                component: EmptyRouterView,
                beforeEnter: defaultBeforeEnter,
            },
            {
                path: 'singleSubCampaignView/:subCampaignId',
                name: routeNames.preparationSingleSubCampaignView,
                component: EmptyRouterView,
                meta: {
                    recordRecentlyOpenedInShell: recordSubCampaignInShell,
                    tabTitle: recordSubCampaignInShell.title,
                },
                beforeEnter: defaultBeforeEnter,
            },
        ],
    },
];

export default routes;
